import "core-js/stable";
import Vue from "vue";
import Vuex from "vuex";
import App from "./savings-calc/App.vue";
import store from "./savings-calc/store/index";
import vmodal from "vue-js-modal";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
import VueGtag from "vue-gtag";

import savingsCalc from "../scss/savings-calc.scss";

Vue.use(LottieVuePlayer);
Vue.use(vmodal);
Vue.use(VueGtag, {
  config: { id: "UA-62098723-1" },
});

/**
 * Set the wizard config context based on the wizardConfig Object which is set on the WizardPage.ss of the brand website
 * **/
function hydrateApp() {
  let viewContent = window.calcContent ? window.calcContent : {};
  let calcConfig = window.calcConfig ? window.calcConfig : {};

  store.commit("updateField", {
    path: "viewContent",
    value: viewContent,
  });
  store.commit("updateField", {
    path: "config.baseUrl",
    value: calcConfig.baseUrl,
  });
}

/**
 * Set up config
 * **/
function init() {
  hydrateApp();

  new Vue({
    el: "#saving-calc-app",
    store,
    render: (h) => h(App),
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});
